import { axiosRequest } from '@planbord/axios-request';
import { useMutation } from '@tanstack/vue-query';

export const useUpdateRemark = () => {
  const baseUrl = '/api';

  return useMutation({
    mutationFn: (value: { ScheduleId: number; RemarkText: string }) =>
      axiosRequest
        .put(`${baseUrl}/remarks/${value.ScheduleId}`, value.RemarkText)
        .then((res) => {
          return { data: res.data, status: res.status}
        }),
  });
};
